/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Injectable } from '@angular/core';
import {
  NbAuthResult,
  NbAuthStrategyClass,
  NbAuthStrategyOptions,
} from '@nebular/auth';
import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { GoogleAuthProvider, signInWithPopup } from '@angular/fire/auth';
import { NbFirebaseBaseStrategy } from '../base/firebase-base.strategy';
import { NbFirebaseIdentityProviderStrategyOptions } from '../base/firebase-identity-provider-strategy.options';

@Injectable()
export class NbFirebaseGoogleStrategy extends NbFirebaseBaseStrategy {
  protected override defaultOptions: NbFirebaseIdentityProviderStrategyOptions =
    new NbFirebaseIdentityProviderStrategyOptions();

  static setup(
    options: NbFirebaseIdentityProviderStrategyOptions,
  ): [NbAuthStrategyClass, NbAuthStrategyOptions] {
    return [NbFirebaseGoogleStrategy, options];
  }

  authenticate(): Observable<NbAuthResult> {
    const module = 'authenticate';
    const provider = new GoogleAuthProvider();
    const scopes = this.getOption('scopes');
    scopes.forEach((scope: string) => provider.addScope(scope));
    provider.setCustomParameters(this.getOption('customParameters'));

    return from(
      this.inContext(() => signInWithPopup(this.afAuth, provider)),
    ).pipe(
      switchMap((res) => this.processSuccess(res, module)),
      catchError((error) => this.processFailure(error, module)),
    );
  }
}
